import React from "react";
import {inject, observer } from 'mobx-react';
import {observe} from 'mobx';
import SearchField from "./SearchField";
import HttpClient from "services/HttpClient";
import "styles/css/pagination.scss";
import EMPTY from "styles/img/empty_results.svg";
import Pagination from "./Pagination";
import SponsoredSingleWorkshop from "components/in_progress/SponsorItem";

const GET_SPONSORED_WORKSHOPS = "/api/v1/workshops/iacp/?";

@inject('SponsorStore', "alert", 'user', 'searchFieldEventEmitter')
@observer
class SponsorWorkshops extends React.Component {
  state = {
    workshops: [],
    type: null,
    title: '',
    pagesCount: 0,
    modalOpened: false,
  };

  componentWillMount = () => {
    this.loadNewByUrl('');
  }

  componentDidMount = () => {
    this.runSearch = observe(this.props.searchFieldEventEmitter, 'event', () => this.loadNewByUrl());
    this.showPage = observe(this.props.searchFieldEventEmitter, 'page', () => this.loadNewByUrl());
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex';
    document.head.appendChild(metaRobots);
  }

  componentWillUnmount = () => {
    this.runSearch();
  }

  buildPath = () => {
    const title = this.state.title ? this.state.title : null ;
    const page = this.props.searchFieldEventEmitter.page;

    if (title && page) {
      return `&title=${title}&page=${page}`;
    } else if (title && !page) {
      return `&title=${title}`;
    } else if (!title && page) {
      return `&page=${page}`;
    }
    return '';
  }

  loadNewByUrl = type => {
    var path = this.buildPath();
    new HttpClient().get(GET_SPONSORED_WORKSHOPS + path).then(response => {
      this.setState({
        workshops: response.body.data.workshops,
        count: response.body.data.count,
        pagesCount: response.body.data.pages,
      });
      window.scrollTo(0, 0);
      this.props.searchFieldEventEmitter.setTotalPages(
        response.body.data.pages
      );
    });
  }

  handleChangeTitle = newTitle => {
    this.setState({ title: newTitle });
  };

  closeIcon = () => {
    this.setState({ title: "" }, () => {
      this.props.searchFieldEventEmitter.activate();
    });
  };

  render() {
    return (
      <main className="main-content">
        <div className="container-fluid workshop-list dashboard spnsrd">
            <SearchField
              submitFilter={this.loadNewByUrl}
              count={this.state.count}
              value={this.state.title}
              handleChangeTitle={this.handleChangeTitle}
              closeIcon={this.closeIcon}
            />
            <div className="row"> 
              <div className="col">
                <div className="section-holder workshop-card-holder">
                  <div className="section-holder-inner" style={{ position: "relative", minHeight: 300 }}>
                    {this.state.workshops.length === 0 && (
                      <div style={{ position: "absolute", top: "40%", left: "50%" }}>
                        <div
                          style={{
                            backgroundColor: "#ebebeb",
                            width: 64,
                            height: 64,
                            borderRadius: "50%",
                            marginLeft: -32
                          }}
                        >
                          <img
                            src={EMPTY}
                            alt=""
                            style={{ marginLeft: 21.5, marginTop: 22 }}
                          />
                        </div>
                        <p
                          style={{
                            opacity: 0.87,
                            width: 300,
                            marginLeft: -150,
                            fontSize: 20,
                            marginTop: 10,
                            lineHeight: 1.25,
                            textAlign: "center",
                            letterSpacing: 0.1,
                            color: "rgba(0, 0, 0, 0.54)"
                          }}
                        >
                          There are no Workshops matching your chosen criteria.
                        </p>
                      </div>
                    )}
                    <div className="row">
                        {this.state.workshops.map(el => {
                          if (el.workshop_type === "online" || el.workshop_type === "live" || el.workshop_type === 'group_supervision')
                            return (
                                <SponsoredSingleWorkshop
                                  data={el}
                                  key={el.id}
                                  user={this.props.user}
                              />
                            );
                          })
                        }
                    </div>

                    <div className="row">
                      <div className="col">
                        {this.state.count ? <Pagination /> : null}
                      </div>
                    </div>
                  </div>  
                </div>
              </div>  
            </div>

          </div>
      </main>
    )
  }
}

export default SponsorWorkshops;


// WEBPACK FOOTER //
// ./src/components/providers/SponsorWorkshops.jsx